exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "tags-input.ng-invalid .tags{border:thin solid #ccc;box-shadow:none}.has-error tags-input.ng-invalid .tags{border:thin solid maroon}", ""]);

// exports
